import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LoopBackAuth, UserDataApi } from '../../../assets/js/lb-sdk/services';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  carousel:Array<boolean> = [
    true,
    false,
    false,
    false
  ];

  constructor(private loopBackAuth: LoopBackAuth,
    private user: UserDataApi,
    private httpClient: HttpClient) { }

  ngOnInit() { 
    // Load XSRF-TOKEN. ignore api error
    this.httpClient.get('/api').subscribe(value => value);
  }

  next(to) {
    for (const i of Object.keys(this.carousel)) {
      this.carousel[i] = false;
    }
    this.carousel[to] = true;
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}

